import React from 'react';

const CatalogueContext = React.createContext();

export default CatalogueContext;
